import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/system';

import ShareVisibilityIcon from '../ShareVisibilityIcon';
import { CompactActionButton } from './styles';

// ShareVisibilityIcon renders a plain svg, not a MuiSvgIcon. The card
// stylesheets that size icons by class miss it - size it here.
const ICON_SIZE = { width: 18, height: 18 };

/**
 * A card's share control, the card-sized twin of the hero pages' ShareButton.
 */
export default function CardShareAction({
  hasPublicData, changes, title, onShare, className,
}) {
  if (hasPublicData && changes === 'none') {
    return (
      <Box
        className={className}
        title={title}
        sx={{ display: 'flex', alignItems: 'center', padding: '4px' }}
      >
        <ShareVisibilityIcon isPublic changes="none" style={ICON_SIZE} />
      </Box>
    );
  }

  return (
    <CompactActionButton className={className} title={title} onClick={onShare}>
      <ShareVisibilityIcon isPublic={hasPublicData} changes={changes} style={ICON_SIZE} />
    </CompactActionButton>
  );
}

CardShareAction.propTypes = {
  hasPublicData: PropTypes.bool,
  changes: PropTypes.oneOf(['unknown', 'some', 'none']),
  title: PropTypes.string,
  onShare: PropTypes.func,
  className: PropTypes.string,
};

CardShareAction.defaultProps = {
  hasPublicData: false,
  changes: 'unknown',
  title: '',
  onShare: null,
  className: undefined,
};
